import { tr } from "@/i18n/copy";
import { Component } from "react";

// A render failure must leave a usable way back into the same Studio.
export default class ClientErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (!this.state.failed) return this.props.children;
    const current = new URLSearchParams(this.props.search || "");
    const home = new URLSearchParams();
    for (const key of ["studio", "brand"]) {
      if (current.get(key)) home.set(key, current.get(key));
    }
    const homeHref = `/client${home.size ? `?${home}` : ""}`;
    return <main className="grid min-h-screen place-items-center bg-background p-6 text-foreground" data-testid="client-error-recovery">
      <section role="alert" className="max-w-md space-y-4 rounded-xl border bg-card p-5">
        <h1 className="text-xl font-semibold">{tr("Non è stato possibile aprire questa schermata")}</h1>
        <p>{tr("Puoi riprovare oppure tornare alla Home dello Studio.")}</p>
        <div className="flex flex-wrap gap-3">
          <button type="button" className="min-h-11 rounded-lg border px-4" onClick={() => this.setState({ failed: false })}>{tr("Riprova")}</button>
          <a className="inline-flex min-h-11 items-center rounded-lg border px-4" href={homeHref}>{tr("Torna alla Home")}</a>
        </div>
      </section>
    </main>;
  }
}
